import { apiFetch } from "@ecom/ui/utils/api"
import pushToDataLayer from "@ecom/ui/utils/pushToDataLayer"
import { orderPathPrefix } from "../../helpers/enviroments"
import { PlacementsESIA } from "./types"
import { ESIA_API_BASE_URL } from "../../helpers/api"

export async function fetchESIAUrl(productName: string = "", placement: PlacementsESIA) {
  const pn = encodeURIComponent(productName)

  const apiId = sessionStorage.getItem("requestId")

  const redirectUrl = encodeURIComponent(
    window.location.origin + window.location.pathname + window.location.search
  )

  const redirectSuccess = orderPathPrefix
    ? encodeURIComponent(`${window.location.origin}/order/success-esia?phone&apiId`)
    : encodeURIComponent(`${window.location.origin}/success-esia?phone&apiId`)

  const redirectError = orderPathPrefix
    ? encodeURIComponent(`${window.location.origin}/order/error-esia`)
    : encodeURIComponent(`${window.location.origin}/error-esia`)

  const redirectRepeated = orderPathPrefix
    ? encodeURIComponent(`${window.location.origin}/order/error-repeat-esia`)
    : encodeURIComponent(`${window.location.origin}/error-repeat-esia`)

  const rejectedRedirectUrl = orderPathPrefix
    ? `${origin}/order/error-reject-esia`
    : `${origin}/error-reject-esia`

  const pathShortESIA = `${ESIA_API_BASE_URL}/?redirect=${redirectUrl}&redirectSuccess=${redirectSuccess}&redirectError=${redirectError}&redirectRepeated=${redirectRepeated}&redirectReject=${rejectedRedirectUrl}&pn=${pn}&placement=${placement}${
    apiId ? `&apiId=${apiId}` : ""
  }`

  return apiFetch(pathShortESIA, {
    credentials: "include",
  })
    .then((res: Response) => {
      if (!res.ok) {
        throw Error(`HTTP error. Status code: ${res.status}`)
      }

      return res.json()
    })
    .then(({ url }: any) => url)
    .catch((error: Error) => {
      pushToDataLayer({
        event: "Esia",
        name: "ServiceLoading",
        result: "error",
        placement,
        eventLabel: globalThis?.location?.href,
      })
      throw error
    })
}
